import React, { useState, useEffect } from "react";
import dashboardclasses from "../../dashboard.module.css";
import { IoClose } from "react-icons/io5";
import { FileUploader } from "react-drag-drop-files";
import { BsCloudUpload } from "react-icons/bs";
import { useForm } from "react-hook-form";
import { Services } from "../../../Services";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
function AddCategory(props) {
    const Navigate = useNavigate();

    const token = { Authorization: `token ${sessionStorage.getItem("token")}` };
    const {
        register,
        handleSubmit,
        reset,
        setValue,
        watch,
        formState: { errors },
    } = useForm({
        defaultValues: {
            hourly_price: {
                1: "",
                2: "",
                3: "",
                4: "",
                5: "",
                6: "",
                7: "",
                8: "",
            },
        },
    });
    const [base64, setbase64] = useState("");
    const formData = watch();
    useEffect(() => {
        if (props.editable) {
            reset({ ...props.editable });
            setbase64(props.editable.subServiceImageURL);
        }
        const close = (e) => {
            if (e.key == "Escape") {
                console.log("close");
                props.setmodal(false);
                props.setEditable(false);
                reset({
                    hourly_price: {
                        1: "",
                        2: "",
                        3: "",
                        4: "",
                        5: "",
                        6: "",
                        7: "",
                        8: "",
                    },
                });
            }
        };
        window.addEventListener("keydown", close);
        return () => window.removeEventListener("keydown", close);
    }, []);

    const CancelHandler = (e) => {
        e.stopPropagation();
        props.setmodal(false);
        props.setEditable(false);
    };

    const openhandler = (e) => {
        e.stopPropagation();
    };
    const handleChange = (file) => {
        if (file.type === "image/png" || file.type === "image/jpeg") {
            const timestamp = Date.now();

            /*   let reader = new FileReader();
                  reader.readAsDataURL(file);
                  reader.onload = function () {
                      setbase64(reader.result);
                      // setValue("banner_image", reader.result);
                  };
                  reader.onerror = function (error) {
                      console.log("Error: ", error);
                  }; */
            let body = new FormData();
            body.append("image", file);
            body.append("folder", "services/sub");
            body.append("bucketName", "heyman-s3");
            Services.UploadImage("POST", body, token)
                .then((res) => {
                    console.log(res);
                    setbase64(res.ImageURL);
                    setValue("subServiceImage", res?.ImageID);
                    console.log(res);
                })
                .catch((err) => {
                    alert(err);
                    console.log(err);
                });
        } else {
            alert("please upload image in PNG and JPEG format ");
        }
    };

    const fileuploadDesign = (
        <div className={dashboardclasses["add-item"]}>
            <BsCloudUpload className={dashboardclasses["upload-icon"]} />
            <h5>Drag Your Image here</h5>
            <p>(Only *.jpeg and *.png images will be accepted)</p>
        </div>
    );
    const onSubmit = (data) => {
        if (!props.editable) {
            let body = { ...data };
            if (body?.booking_type != 5) delete body.hourly_price;
            Services.AddTransportServices("POST", JSON.stringify(body), token)
                .then((res) => {
                    // props.tableload(false);
                    if (res.Status === 1) {
                        props.setmodal(false);
                        props.getCategories();
                        reset({
                            hourly_price: {
                                1: "",
                                2: "",
                                3: "",
                                4: "",
                                5: "",
                                6: "",
                                7: "",
                                8: "",
                            },
                        });
                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch((err) => {
                    alert("something went wrong please try again");
                    console.log(err);
                });
        } else if (props.editable) {
            let body = { ...data };
            if (body?.booking_type != 5) delete body.hourly_price;
            Services.updateTransportServices(
                "PATCH",
                JSON.stringify(body),
                token,
                props.editable.subServiceId
            )
                .then((res) => {
                    if (res.Status === 1) {
                        props.setmodal(false);
                        props.getCategories();
                        props.setEditable(false);
                        reset({
                            hourly_price: {
                                1: 0,
                                2: 0,
                                3: 0,
                                4: 0,
                                5: 0,
                                6: 0,
                                7: 0,
                                8: 0,
                            },
                        });
                        toast.success(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    } else if (res.Status === 0) {
                        toast.error(`${res.Message}`, {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch((err) => {
                    // alert(err);
                    alert("something went wrong please try again");
                    console.log(err);
                });
        }
    };
    const hourLabels = [
        "1st hour",
        "2nd hour",
        "3rd hour",
        "4th hour",
        "5th hour",
        "6th hour",
        "7th hour",
        "8th hour",
    ];

    return (
        <div className={dashboardclasses.modal} onClick={CancelHandler}>
            <div
                className={dashboardclasses["modal-content"]}
                onClick={openhandler}>
                <div className={dashboardclasses["modal-content-header"]}>
                    <div>
                        <h3>
                            {props.editable
                                ? "Update Transport Charges"
                                : "Add Transport Charges"}
                        </h3>
                        <p>
                            {props.editable
                                ? "Update Transport Charges"
                                : "Add Transport Charges"}{" "}
                            and necessary information from here
                        </p>
                    </div>
                    <button
                        className={dashboardclasses["close-btn"]}
                        onClick={CancelHandler}>
                        <IoClose size={22} color={"red"} />
                    </button>
                </div>
                <form
                    className={dashboardclasses["add-items"]}
                    onSubmit={handleSubmit(onSubmit)}>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryName">Sub Service Name</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                {...register("subServiceName", {
                                    required: "Sub Service Name is required",
                                })}
                            />

                            {errors?.subServiceName && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.subServiceName?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="categoryName">
                            Sub Service Caption
                        </label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                {...register("subServiceCaption", {
                                    required: "Sub Service Caption is required",
                                })}
                            />

                            {errors?.subServiceCaption && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.subServiceCaption?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="category">Sub Service Image</label>

                        <FileUploader
                            classes={dashboardclasses["upload-image"]}
                            multiple={false}
                            handleChange={handleChange}
                            name="file"
                            children={fileuploadDesign}
                        />
                    </div>
                    <div className={dashboardclasses["uploaded-img"]}>
                        <img src={base64} alt="" width={"120px"} />
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="">Base Fare KM</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="number"
                                step={0.001}
                                {...register("base_fare_km", {
                                    required: "Base Fare KM is required",
                                })}
                            />
                            {errors?.base_fare_km && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.base_fare_km?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="">Base Fare min</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="number"
                                step={0.001}
                                {...register("base_fare_minute", {
                                    required: "Base Fare min is required",
                                })}
                            />
                            {errors?.base_fare_minute && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.base_fare_minute?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="">Base Fare amount</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="number"
                                step={0.001}
                                {...register("base_fare_amount", {
                                    required: "Base Fare amount is required",
                                })}
                            />
                            {errors?.base_fare_amount && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.base_fare_amount?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="">Add.l price per km</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="number"
                                step={0.001}
                                {...register("additional_price_per_km", {
                                    required:
                                        "Add.l price per km amount is required",
                                })}
                            />
                            {errors?.additional_price_per_km && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.additional_price_per_km?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="">Add.l price per min</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="number"
                                step={0.001}
                                {...register("additional_price_per_minute", {
                                    required:
                                        "Add.l price per min amount is required",
                                })}
                            />
                            {errors?.additional_price_per_minute && (
                                <p className={dashboardclasses["error"]}>
                                    {
                                        errors?.additional_price_per_minute
                                            ?.message
                                    }
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="">Night charges</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="number"
                                step={0.001}
                                {...register("night_charges", {
                                    required:
                                        "Night Charges amount is required",
                                })}
                            />
                            {errors?.night_charges && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.night_charges?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="">Min Fare</label>
                        <div className={dashboardclasses["select"]}>
                            <input
                                type="number"
                                step={0.001}
                                {...register("minimum_fare", {
                                    required: "Min Fare is required",
                                })}
                            />
                            {errors?.minimum_fare && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.minimum_fare?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="status">Booking Type</label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                {...register("booking_type", {
                                    required: "Booking Type is required",
                                })}>
                                <option value="1">Share Ride </option>
                                <option value="3">Classic Ride</option>
                                <option value="4">One way </option>
                                <option value="5">Round trip </option>
                            </select>
                            {errors?.booking_type && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.booking_type?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    {formData?.booking_type == "5" &&
                        [...Array(8)].map((_, index) => {
                            const hour = (index + 1).toString();

                            return (
                                <div
                                    className={
                                        dashboardclasses["item-image-upload"]
                                    }>
                                    <label htmlFor={`hourly_price_${hour}`}>
                                        Hourly Price ({hour} hour)
                                    </label>
                                    <div className={dashboardclasses["select"]}>
                                        <input
                                            type="number"
                                            step="0.01"
                                            id={`hourly_price_${hour}`}
                                            {...register(
                                                `hourly_price.${hour}`,
                                                {
                                                    required: `${hour} hour is required`,
                                                    valueAsNumber: true,
                                                }
                                            )}
                                        />
                                        {errors.hourly_price?.[hour] && (
                                            <p className="text-red-500 text-sm">
                                                {
                                                    errors.hourly_price[hour]
                                                        .message
                                                }
                                            </p>
                                        )}
                                    </div>
                                </div>
                            );
                        })}

                    <div className={dashboardclasses["item-image-upload"]}>
                        <label htmlFor="status">Status</label>
                        <div className={dashboardclasses["select"]}>
                            <select
                                {...register("status", {
                                    required: "status is required",
                                })}>
                                <option value="1">Active</option>
                                <option value="0">Inactive</option>
                            </select>
                            {errors?.status && (
                                <p className={dashboardclasses["error"]}>
                                    {errors?.status?.message}
                                </p>
                            )}
                        </div>
                    </div>

                    <div className={dashboardclasses["add-btn"]}>
                        <button type="button" onClick={CancelHandler}>
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className={dashboardclasses["add-category-btn"]}>
                            {props.editable
                                ? "update"
                                : "Add Transport Charges"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AddCategory;
